module.exports = __webpack_public_path__ + "static/media/Xeirokrotima_5.c9d05e5f.jpg";